import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_1: FaireProductEntity = {
  token: "matcha-1",
  type: "product",
  name: "New Ceremonial Matcha",
  brandName: "DON",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/deae64312f6a0eb1879723c27396b49c86c203100739e18bfc18fdb2bf9b7994.png",
  priceDollars: 275,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/deae64312f6a0eb1879723c27396b49c86c203100739e18bfc18fdb2bf9b7994.png",
  weight: 0.3,
  dimensions: {
    width: 4,
    height: 6,
    depth: 2,
  },
  description: "Premium ceremonial grade matcha from DON",
  categoryTokens: ["cat_food-beverages"],
  tags: [
    "matcha",
    "tea",
    "japanese-green-tea",
    "ceremonial",
    "premium",
    "wellness",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
